import { Controller } from "@hotwired/stimulus"
import { parseAmount } from "../lib/parse_amount"

// Zeigt eine Warnung, wenn eine Ausgabe den aktuellen Kontostand uebersteigt.
// Connects to data-controller="pocket-money-form"
export default class extends Controller {
  static targets = ["amount", "direction", "warning"]
  static values = { balanceCents: Number }

  check() {
    const magnitude = Math.round((parseAmount(this.amountTarget.value) || 0) * 100)
    const isExpense = this.directionTargets.some((el) => el.checked && el.value === "expense")
    const resulting = this.balanceCentsValue - (isExpense ? magnitude : 0)
    this.warningTarget.classList.toggle("hidden", !(isExpense && resulting < 0))
  }
}
